module.exports = __webpack_public_path__ + "h5/img/points_gift.18b31504.png";